import { Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import KDrawer from 'app/components/Modules/Feedback/KDrawer'
import { KDrawerProps } from 'app/components/Modules/Feedback/typing'
import KCol from 'app/components/UI-Elements/Layout/KCol'
interface Props extends Omit<KDrawerProps, 'drawerType'> {
  loading?: boolean
}

const CheckoutDrawer: React.FC<Props> = ({
  children,
  title,
  onClose,
  loading,
  open,
  ...others
}) => {
  const { md } = useBreakpoint()

  return (
    <KDrawer
      width={600}
      closable={false}
      drawerType="page"
      title={title || '-'}
      destroyOnClose
      push={false}
      open={open}
      onClose={onClose}
      {...others}>
      <Choose>
        <When condition={loading}>
          <Row>
            <KCol card={!md} span={24} loading={loading} />
          </Row>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
    </KDrawer>
  )
}

export default CheckoutDrawer
